import { createContext, useContext } from "react";

export const PageContext = createContext({});

export const useAreaDetailPageContext = () => useContext(PageContext);

export function buildAreaRoute(clientId, projectId, areaId) {
  return areaId && `/clients/${clientId}/projects/${projectId}/areas/${areaId}`;
}
